import { useModals } from 'almanac-ui/Modal'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { FileMoveAttemptResult, FileMoveAttemptsClient } from 'api/FileMoveAttemptsClient'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { MoveConfirmationModal } from 'components/MoveConfirmationModal/MoveConfirmationModal'
import { moveError } from 'components/NavRightClickMenu/components/MoveError/MoveError'
import { SelectedFolder } from '../LocationPicker'
import { useBrand } from 'hooks/useBrand'

export interface OnSelectFolderPayload {
  selectedFolder: SelectedFolder | null
  newWorkspaceId: number
}

export interface FileMoveAttemptPayload {
  folderIds: string[]
  articleIds: string[]
  originalWorkspaceId: number
}

export const useEvaluateMove = () => {
  const { openModal, closeModal } = useModals()
  const { defaultFoldersLocation } = useBrand()
  return {
    evaluateMove: async ({
      onSelectFolderPayload,
      fileMoveAttemptPayload,
      handleMove,
    }: {
      onSelectFolderPayload: OnSelectFolderPayload
      fileMoveAttemptPayload: FileMoveAttemptPayload
      handleMove: (payload: OnSelectFolderPayload) => void
    }) => {
      const { selectedFolder, newWorkspaceId } = onSelectFolderPayload
      const { folderIds, articleIds, originalWorkspaceId } = fileMoveAttemptPayload
      const dismissPermissionsToast = showToastMessage('Checking permissions...')

      const response = await FileMoveAttemptsClient.create({
        folderIds,
        articleIds,
        destinationFolderId: selectedFolder?.id ?? null,
        destinationWorkspaceId: newWorkspaceId,
        originalWorkspaceId,
      })
      dismissPermissionsToast()

      if (response.type === 'error') {
        moveError({ status: response.status, data: response.data })
        return
      }

      if (response.type === SUCCESS_RESPONSE_TYPE && response.data !== FileMoveAttemptResult.NoChange) {
        openModal(MoveConfirmationModal, {
          newParentFolderTitle: selectedFolder?.title || defaultFoldersLocation,
          fileMoveAttemptResult: response.data,
          onSubmit: () => {
            handleMove(onSelectFolderPayload)
          },
          closeModal,
        })
        return
      }

      handleMove(onSelectFolderPayload)
    },
  }
}
